<template>
  <div class="container">
    <CollapsibleListItem icon="mdi-certificate" :title="$t('MEMBERSHIP.MEMBERSHIPS')" :expanded="false">
      <memlist-static-table
        id="member-table"
        style="width: 100%; table-layout: fixed;"
        class="table-striped"
        :fields="fields"
        :items="items"
        head-variant="light"
        ref="memberTable"
      >
        <template #cell(actions)="row">
        
          <a class="btn btn-icon btn-light btn-sm mx-2" v-if="has_certificate" href="#" @click.prevent="download_certificate(row.item.member_company_id)">
            <span class="svg-icon svg-icon-md svg-icon-primary">
              <inline-svg src="/assets/svg/certificate.svg"></inline-svg>
            </span>
          </a>

        </template>


      </memlist-static-table>

    </CollapsibleListItem>

  </div>

</template>

<script>

import axios from 'axios';
import dayjs from 'dayjs';
import { toasts } from '@/core/mixins/toastr-helper.mixin.js';
import { is_mobile } from '@/core/services/utils';
import { get_base_url, downloadWithAxios } from '@/core/services/fileDownload';
import CollapsibleListItem from './CollapsibleListItem.vue';

export default {

  name: 'MemberTableMemberships',

  props: ['member','items','company','expanded','is_faith','has_certificate'],
  emits: ['save_data'],
  mixins: [ toasts ],

  components: {
    CollapsibleListItem
  },

  watch: {

  },

  computed: {
    show_certificate() {

    },
    is_mobile() {
      return is_mobile();
    },
  },

  methods: {

    delay(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },

    async download_certificate(member_company_id) {
      const loader = this.$loading.show();

      try {
        const res = await axios.post(`/pdf_template/membership/member/${member_company_id}`);

        if (res.status === 201) {
          downloadWithAxios(get_base_url() + `/dlfile/${res.data.linkstr}`, res.data.name);
        }
      }
      catch (err) {
        console.error(err);
        
        this.toastr('danger', this.$t('COMMON.ERROR'), this.$t('PDF_TEMPLATE.UNABLE_CREATE'));
      }

      loader && loader.hide();
      
    },

    async save_data() {

      this.$emit('save_data', this.member);

    }

  },

  mounted() {
    this.show_form = this.expanded;

    if (this.is_mobile) {
      this.fields = this.fields.filter((field) => {
        return field.mobile;
      });
    }

    if (this.is_faith) {
      this.fields = this.fields.filter(item => item.key !== 'vtdt' && item.key !== 'vtdt' && item.key !== 'is_paid');
    }
  },

  data() {
    return {

      fields: [
        {
          key: 'company.name',
          label: this.$t('COMPANY.NAME'),
          sortable: false,
          mobile: true,
          tdClass: 'td-short2',
          thClass: 'td-short2'
        },
        {
          key: 'reg_at',
          label: this.$t('MEMBERSHIP.REG_AT'),
          sortable: false,
          mobile: false,
          tdClass: 'td-short2',
          thClass: 'td-short2'
        },
        {
          key: 'vtdt',
          label: this.$t('MEMBERSHIP.VTDT'),
          sortable: false,
          mobile: true,
          tdClass: 'td-short2',
          thClass: 'td-short2'
        },
        {
          key: 'is_paid',
          label: this.$t('MEMBERSHIP.IS_PAID'),
          sortable: false,
          mobile: true,
          tdClass: 'td-short2',
          thClass: 'td-short2',
          formatter: (_, __, item) => {
            return item.is_paid ? this.$t('COMMON.YES') : this.$t('COMMON.NO');
          }
        },
        {
          key: 'actions',
          label: this.$t('COMMON.ACTIONS'),
          sortable: false,
          mobile: true,
          tdClass: 'td-short2',
          thClass: 'td-short2'
        },
      ],

      show_form: true,

    };
  }
};

</script>

<style lang="scss" scoped>
  
  
</style>
